/**
 * Клиентский адаптер резолва URL файла: контракт из common/fileUrl, база — apiBaseUrl
 * браузера (прод — '' = same-origin, dev — VITE_SERVER_*). Для ссылок, отображаемых
 * в SPA (src/href/window.open). Ссылка уходит из браузера (Telegram, письмо,
 * внешний API-ответ) — это серверный адаптер `server/services/fileUrl.ts`, не этот.
 */
import { apiBaseUrl } from '@ayocore/platform/client/helpers/fetcher';
import { resolveFileUrl as resolveFileUrlCore } from '../common/fileUrl';

/**
 * Итоговый URL файла для показа в браузере: абсолютный `public_url` (s3-public) — как есть,
 * относительный (local, s3-private) — с префиксом apiBaseUrl.
 */
export function resolveFileUrl(publicUrl: string | null | undefined): string {
  return resolveFileUrlCore(publicUrl, apiBaseUrl);
}
